import styled from 'styled-components';

export default styled.div`
  cursor: pointer;
  border: 2px solid var(--primary);
  padding: 0.6rem;
  border-radius: 8px;
  color: var(--primary);
  border: none;
  transition-property: color, background-color;
  transition: 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    font-size: 2.5rem;
  }
  * {
    pointer-events: none;
  }
  &:hover {
    color: var(--white-1);
  }
  @media only screen and (max-width: 768px) {
    padding-inline: 1.5rem;
    padding-top: 10px;
    svg {
      font-size: 1.8rem;
    }
  }
`;
